import ClickLogger from '@/components/common/ClickLogger';
import { MedicalCategoryModel } from '@/entities/medical-category';
import { CATEGORY_ITEM_STYLES } from '../lib/constants';

interface CategoryItemProps {
  category: MedicalCategoryModel;
  onClickCategory: () => void;
}

const CategoryItem = ({ category, onClickCategory }: CategoryItemProps) => {
  return (
    <ClickLogger params={{ eventName: 'category_item_click', payload: { categoryId: category.id ?? '' } }}>
      <span className='cursor-pointer' onClick={onClickCategory}>
        <a className='flex min-h-[88px] cursor-pointer flex-col items-center justify-center gap-[12px] rounded-[8px] p-[8px] sm:min-h-[108px]'>
          <div className={CATEGORY_ITEM_STYLES.ICON_CONTAINER}>
            <img src={category.iconUrl ?? ''} alt={category.name ?? ''} className={CATEGORY_ITEM_STYLES.ICON} />
          </div>
          <span className={CATEGORY_ITEM_STYLES.NAME}>{category.name ?? ''}</span>
        </a>
      </span>
    </ClickLogger>
  );
};

export default CategoryItem;
